<template>
    <div class="top-section" :style="bgColor" :class="{ 'remove-pt': ribbonMobile }">
        <img class="ribbon-desktop" :src="ribbonDesktop" alt="">
        <img class="ribbon-mobile" :src="ribbonMobile" alt="">

        <img v-if="!ribbonDesktop" class="emblem-left desktop-emblem-left" src="@/assets/images/decoration/flowers-right-vertical.png" alt="flower-illustration">
        <img v-if="!ribbonDesktop" class="emblem-right desktop-emblem-right" src="@/assets/images/decoration/flowers-right-vertical.png" alt="flower-illustration">
        <img v-if="!ribbonMobile" class="emblem-left mobile-emblem-left" src="@/assets/images/decoration/flowers-right-horizontal.png" alt="flower-illustration">
        <img v-if="!ribbonMobile" class="emblem-right mobile-emblem-right" src="@/assets/images/decoration/flowers-right-horizontal.png" alt="flower-illustration">

        <h2 class="subscription-title" :class="{'text-capitalize': capitalizeName}">{{ dashboardTitle }}</h2>
        <p class="subscription-message">{{ dashboardMessage }}</p>
        <div class="flex flex-wrap justify-center menu-section padding-box" style="margin-bottom: 35px">
            <div v-for="item in tiles" :key="item.label" class="w-1/2 md:w-1/4 mb-2 md:mb-3 lg:mb-6">
                <icon-box :icon="item" :hasGiftingCoupon="hasGiftingCoupon" :isLoaded="enableTiles"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate, diffCalendarDays } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import { IconBox } from '@/components/partials/account/dashboard';

export default {
    name: 'SubscriptionState',
    props: {
        tiles: {
            type: Array,
        },
        hasGiftingCoupon: {
            type: Boolean,
        },
        enableTiles: {
            type: Boolean,
        },
        nearestUpcomingDate: {
            type: String,
        },
    },
    components: {
        IconBox,
    },
    computed: {
        ...mapGetters({
            firstName: 'account/getFirstName',
            themes: 'account/getThemes',
        }),
        dashboardTitle() {
            if (this.nearestUpcomingDate) {
                if (this.daysLeft === 0) return this.$t('DASHBOARD_TITLE_DELIVERY_DAY');
                if (this.daysLeft < 3) return this.$t('DASHBOARD_TITLE_DURING_CUT_OFF', { days: this.getDaysString });
                if (this.daysLeft > 5) return this.$t('DASHBOARD_TITLE_HELLO_FIRST_NAME', { firstName: this.firstName });
                if (this.daysLeft >= 3 && this.daysLeft <= 5) return this.$t('DASHBOARD_TITLE_5_DAYS_TO_GO');
            }
            return this.$t('DASHBOARD_TITLE_HELLO_FIRST_NAME', { firstName: this.firstName });
        },
        dashboardMessage() {
            if (!this.nearestUpcomingDate) return this.$t('DASHBOARD_MESSAGE_PAUSED');
            if (this.daysLeft === 0) return this.$t('DASHBOARD_MESSAGE_DELIVERY_DAY');
            return this.nearestUpcomingDate && this.$t('DASHBOARD_MESSAGE_NEXT_BOX', { dateString: formatDate(this.nearestUpcomingDate, Dates.DAY_DATE_MONTH) });
        },
        getDaysString() {
            return this.nearestUpcomingDate && (this.daysLeft === 1) ? `${this.daysLeft} ${this.$t('DAY')}` : `${this.daysLeft} ${this.$t('DAYS')}`;
        },
        daysLeft() {
            return this.nearestUpcomingDate && diffCalendarDays(new Date(this.nearestUpcomingDate), new Date());
        },
        capitalizeName() {
            return this.daysLeft > 6 || !this.nearestUpcomingDate;
        },
        bgColor() {
            return `background-color: ${this.themes?.backgroundColor}`;
        },
        ribbonDesktop() {
            return this.themes?.top?.desktop;
        },
        ribbonMobile() {
            return this.themes?.top?.mobile;
        },
    },
};
</script>

<style lang="scss" scoped>
    .top-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #F5EBE1;
        margin-bottom: 48px;
        position: relative;
        top: -1px;
    }

    .emblem-left {
        position: absolute;
        left: 0px;
        top: 0px;
        transform: scaleX(-1);
    }

    .emblem-right {
        position: absolute;
        right: 0px;
        top: 0px;
    }

    .desktop-emblem-left, .desktop-emblem-right {
        height: auto;
        max-height: 300px;
    }

    .mobile-emblem-left, .mobile-emblem-right {
        display: none;
    }

    .menu-section {
        max-width: 824px;
    }

    .subscription-title {
        margin-top: 38px;
        margin-bottom: 0px
    }

    .subscription-message {
        margin-top: 10px;
        margin-bottom: 30px
    }

    .text-capitalize {
        text-transform: capitalize;
    }

    .ribbon-mobile {
        display: none;
    }

    @media (max-width: 1024px) {
        .menu-section {
            margin-bottom: 20px;
            width: 100%;
        }

        .top-section {
            min-height: 408px;
            text-align: center;
            margin-bottom: 40px;
        }

        .desktop-emblem-left, .desktop-emblem-right {
            max-height: 270px;
        }

        .subscription-message {
            max-width: 500px;
        }
    }

    @media (max-width: 768px) {
        .menu-section {
            margin-bottom: 20px;
        }

        .top-section {
            padding-top: 60px;
            min-height: 408px;
            text-align: center;
        }

        .desktop-emblem-left, .desktop-emblem-right {
            max-height: 250px;
        }

        .tiles-section-1 {
            margin-bottom: 48px;
        }

        .ribbon-desktop {
            display: none;
        }

        .ribbon-mobile {
            display: block;
        }

        .remove-pt {
            padding-top: 0px;
            padding-left: 0px;
            padding-right: 0px;
        }

        .padding-box {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    @media (max-width: 767px) {
        .top-section {
            margin-bottom: 32px;
        }

        .desktop-emblem-left, .desktop-emblem-right {
            display: none;
        }

        .mobile-emblem-left, .mobile-emblem-right {
            display: block;
            max-height: 125px;
        }

        .subscription-message {
            max-width: none;
        }
    }

    @media (max-width: 479px) {
        .mobile-emblem-left, .mobile-emblem-right {
            max-height: 100px;
        }
    }
</style>
